import { useEffect, type ReactNode } from 'react';
import { enableReveals } from './choreography.js';

/**
 * Wraps the hydrated tree and turns scroll reveals on from an effect. Effects
 * run after hydration commits (a parent's after its children's, so every
 * Reveal is already observed), which keeps the reveal markers off React-owned
 * nodes while React is still comparing server and client attributes. Renders no
 * DOM of its own, so the server markup it hydrates is unchanged.
 */
export function RevealsAfterHydration({ children }: { children: ReactNode }) {
  useEffect(enableReveals, []);
  return children;
}
